export default __webpack_public_path__ + "static/media/exemple.c6549ef4.xlsx";